export const DEFAULT_LIMIT_OF_PRODUCTS = 10000;



